module.exports = __webpack_public_path__ + "static/media/tick.ce19ee14.svg";